import React, { Component } from "react";
import { Row, Col, Card, Button, Form, Modal } from "react-bootstrap";
import { Scrollbars } from 'react-custom-scrollbars'
import parse, { domToReact } from 'html-react-parser';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";


const EDIT_QUESTION = gql`
    mutation($params:EditQuestionsInput){
      editQuestions(params:$params){
        success
      }
    }
`;


const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

class EditAnswerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            examquestionsData: [],
            selectedAnswers: [],
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            succssError: "",
            dataClear: 0,
        };
    }



    componentDidUpdate(prevProps) {
        if (prevProps.selectedQuestion !== this.props.selectedQuestion) {
            this.setState({
                examquestionsData: JSON.parse(JSON.stringify(this.props.selectedQuestion))
            });
        }


        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                examquestionsData: JSON.parse(JSON.stringify(this.props.selectedQuestion)),
                selectedAnswers: [],
                loadingSpinner: 0,
                currentStep: 1,
                submitError: "",
                succssError: "",
                dataClear: 1,
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }


    idFunction(data) {
        let id = parseInt(data + 1);
        return id;
    }

    // Checkbox options
    // handleAnswerChange = (QID, selectedOption) => {

    //     const updatedQuestions = this.state.examquestionsData.map((q) => {
    //         if (q.id === QID) {
    //             let answerArray = q.answer ? q.answer.split(",").map(a => a.trim()) : [];

    //             // If already selected → remove it
    //             if (answerArray.includes(selectedOption)) {
    //                 answerArray = answerArray.filter(a => a !== selectedOption);
    //             }
    //             else {
    //                 // Add new selected
    //                 answerArray.push(selectedOption);
    //             }

    //             return { ...q, answer: answerArray.join(",") };
    //         }
    //         return q;
    //     });


    //     const updatedSelected = [
    //         ...this.state.selectedAnswers.filter(item => item.question_id !== QID),
    //         {
    //             question_id: QID,
    //             answer: updatedQuestions.find(q => q.id === QID).answer
    //         }
    //     ];

    //     this.setState({
    //         examquestionsData: updatedQuestions,
    //         selectedAnswers: updatedSelected
    //     });
    // };

    //  Radio Options
    handleAnswerChange = (QID, selectedOption) => {
        const updatedQuestions = this.state.examquestionsData.map((q) => {
            if (q.id === QID) {
                // For radio → always replace the answer with the new selection
                return { ...q, answer: selectedOption };
            }
            return q;
        });

        const updatedSelected = [
            ...this.state.selectedAnswers.filter(item => item.question_id !== QID),
            {
                question_id: QID,
                answer: selectedOption
            }
        ];

        this.setState({
            examquestionsData: updatedQuestions,
            selectedAnswers: updatedSelected
        });
    };


    handleTextAnswerChange = (QID, newValue) => {

        const regex = /^\d{0,15}(\.\d{0,50})?$/;

        if (newValue === "" || regex.test(newValue)) {
            const updatedQuestions = this.state.examquestionsData.map(q =>
                q.id === QID ? { ...q, answer: newValue } : q
            );

            const updatedSelected = [
                ...this.state.selectedAnswers.filter(item => item.question_id !== QID),
                { question_id: QID, answer: newValue }
            ];

            this.setState({
                examquestionsData: updatedQuestions,
                selectedAnswers: updatedSelected
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.selectedAnswers.length === 0) {
            this.setState({
                loadingSpinner: 1,
                currentStep: 5,
                succssError: "Question Updation Saved successfully"
            });

            setTimeout(() => {
                this.props.onHide();
                window.location.reload(false);
            }, 1500);

        } else {
            const params = {
                username: "admin",
                exam_paper_id: +this.props.propsData?.exam_paper_id,
                edit_questions: this.state.selectedAnswers
            };
            this.setState({ loadingSpinner: 1 });

            this.editQuestions(params).catch(error => {
                this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
                setTimeout(() => {
                    this.props.onHide();
                    window.location.reload(false);
                }, 1500);
            })
        }
    };

    editQuestions = async params => {
        await this.props.editQuestions({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.editQuestions?.success === true) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                        succssError: "Question Updation Saved successfully"
                    });

                    // this.getQuestions();
                    this.props.history.push("/questions/manage-question-paper");

                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }

            }
        })
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };


    getQuestions = async () => {
        const examPaperId = this.props.propsData?.exam_paper_id;
        const institutionId = parseInt(Cookies.get("institutionid"));

        if (!examPaperId || !institutionId) return;

        const result = await this.props.client.query({
            query: gql`
  query($institution_id: Int!, $exam_paper_id: Int, $page: Int, $limit: Int) {
    manageQuestions(institution_id: $institution_id, exam_paper_id: $exam_paper_id, page: $page, limit: $limit) {
        totalCount
        papers {
            id
            name
            exam_type
            no_of_sets
            start_time
            end_time
            is_completed
            filename
            exam_name
            class
            class_id
            sub_exam_type
            total_question_count
            section
            branch
            student_results{
              session_id
              student_name
              mobile
              email
              branch_id
              class_id
              section_id
              correct
              wrong
              not_answered
              total_questions
              correct_marks
              negative_marks
              total_marks
              accuracy
              speed
              attempted_exam
            }
            exam_questions{
              id
              subject
              chapter
              question
              option1
              option2
              option3
              option4
              qtype
              complexity
              chapter_name
              compquestion
              list1type
              list2type
              mat_question
              answer
              inputquestion
            }
            result_graph{
              limit
              percentage
            }
        }
    }
  }
`,
            variables: {
                institution_id: institutionId,
                exam_paper_id: parseInt(examPaperId),
                page: 1,
                limit: 10
            },
            fetchPolicy: 'network-only'
        });

        console.log("result", result);

    };

    render() {

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Replace Answer</Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-3">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                {
                                    this.state.examquestionsData.length > 0 ? (
                                        <Form.Row>
                                            <Card as={Card.Body}>
                                                <Scrollbars style={{ height: 250 }}
                                                    {...this.props}
                                                    renderThumbVertical={renderThumb}
                                                    autoHide
                                                    autoHideTimeout={500}
                                                    autoHideDuration={200}>
                                                    {this.state.examquestionsData.map((questionsData, index) => {
                                                        if (+questionsData.qtype === 9 || +questionsData.qtype === 3) {
                                                            let question1 = questionsData.question.replace(/src="/g, 'src=\\"');
                                                            let question2 = question1.replace(/" \/>/g, '\\" />');
                                                            let question = [];
                                                            try {
                                                                question = JSON.parse(question2);
                                                            }
                                                            catch (err) {
                                                            }


                                                            return (
                                                                <Card as={Card.Body} className="bg-light my-2">
                                                                    <div>
                                                                        <div
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            <span>{this.idFunction(index)}</span>
                                                                            {parse(questionsData.mat_question)}
                                                                            {" QID- " + questionsData.id}
                                                                        </div>

                                                                        <Row>
                                                                            <Col xl={6} lg={6} md={6} sm={12}>
                                                                                <ol
                                                                                    className="matrixlistoptions"
                                                                                    type={
                                                                                        questionsData.list1type == "alphabets"
                                                                                            ? "A"
                                                                                            : questionsData.list1type == "numbers"
                                                                                                ? "1"
                                                                                                : "roman"
                                                                                    }
                                                                                >
                                                                                    {question.map((item) => (
                                                                                        <li>{parse(item.qlist1)}</li>
                                                                                    ))}
                                                                                </ol>
                                                                            </Col>

                                                                            <Col xl={6} lg={6} md={6} sm={12}>
                                                                                <ol
                                                                                    className="matrixlistoptions"
                                                                                    type={
                                                                                        questionsData.list2type == "alphabets"
                                                                                            ? "A"
                                                                                            : questionsData.list2type == "numbers"
                                                                                                ? "1"
                                                                                                : "roman"
                                                                                    }
                                                                                >
                                                                                    {question.map((item) => (
                                                                                        <li>{parse(item.qlist2)}</li>
                                                                                    ))}
                                                                                </ol>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>

                                                                    <hr className="my-3" />
                                                                    <Row>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>A.</span>
                                                                                <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>B.</span>
                                                                                <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>C.</span>
                                                                                <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>D.</span>
                                                                                <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                                            <div className="font-weight-bold mb-2">Correct Answer:</div>
                                                                            <Row>
                                                                                {["A", "B", "C", "D"].map((option, optIndex) => {
                                                                                    const selectedAnswers = (questionsData.answer || "")
                                                                                        .split(",")
                                                                                        .map(a => a.trim());

                                                                                    const isSingleAnswer = true;

                                                                                    return (
                                                                                        // <Col sm={3} key={optIndex}>
                                                                                        //     <div className={`custom-control ${isSingleAnswer ? "custom-radio" : "custom-checkbox"} mb-1`}>
                                                                                        //         <input
                                                                                        //             type={isSingleAnswer ? "radio" : "checkbox"}
                                                                                        //             id={`opt_${questionsData.id}_${optIndex}`}
                                                                                        //             name={`answer_${questionsData.id}`}
                                                                                        //             className="custom-control-input"
                                                                                        //             checked={selectedAnswers.includes(option)}
                                                                                        //             onChange={() => this.handleAnswerChange(questionsData.id, option)}
                                                                                        //         />

                                                                                        //         <label
                                                                                        //             className="custom-control-label"
                                                                                        //             htmlFor={`opt_${questionsData.id}_${optIndex}`}
                                                                                        //         >
                                                                                        //             {option}
                                                                                        //         </label>
                                                                                        //     </div>
                                                                                        // </Col>


                                                                                        <Col sm={3} key={optIndex}>
                                                                                            <div className="custom-control custom-radio mb-1">
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    id={`opt_${questionsData.id}_${optIndex}`}   // ✅ FIXED
                                                                                                    name={`answer_${questionsData.id}`}
                                                                                                    className="custom-control-input"
                                                                                                    checked={selectedAnswers.includes(option)}
                                                                                                    onChange={() => this.handleAnswerChange(questionsData.id, option)}
                                                                                                />

                                                                                                <label
                                                                                                    className="custom-control-label"
                                                                                                    htmlFor={`opt_${questionsData.id}_${optIndex}`}  // must match exact id
                                                                                                >
                                                                                                    {option}
                                                                                                </label>
                                                                                            </div>
                                                                                        </Col>


                                                                                    );
                                                                                })}
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>

                                                                </Card>)
                                                        }
                                                        else if (+questionsData.qtype === 8) {
                                                            return (
                                                                <Card as={Card.Body} className="bg-light my-2">
                                                                    <div
                                                                        className="p-2"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <span>{this.idFunction(index)}</span>
                                                                        {parse(questionsData.question)}
                                                                        {" QID- " + questionsData.id}
                                                                    </div>

                                                                    <hr className="my-3" />
                                                                    <Row>
                                                                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                                            <div className="font-weight-bold mb-2">Correct Answer:</div>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Answer"
                                                                                value={questionsData.answer || ""}
                                                                                onChange={(e) =>
                                                                                    this.handleTextAnswerChange(questionsData.id, e.target.value)
                                                                                }
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </Card>
                                                            )

                                                        }
                                                        else if (+questionsData.qtype === 5) {
                                                            return (<Card as={Card.Body} className="bg-light my-2">
                                                                <div
                                                                    className="p-2"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {parse(questionsData.compquestion)}
                                                                    <span>{this.idFunction(index)}</span>
                                                                    {parse(questionsData.question)}
                                                                    {" QID- " + questionsData.id}
                                                                </div>

                                                                <hr className="my-3" />
                                                                <Row>
                                                                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                        <div className="d-flex align-items-center">
                                                                            <span>A.</span>
                                                                            <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                        <div className="d-flex align-items-center">
                                                                            <span>B.</span>
                                                                            <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                        <div className="d-flex align-items-center">
                                                                            <span>C.</span>
                                                                            <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                        <div className="d-flex align-items-center">
                                                                            <span>D.</span>
                                                                            <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    {["A", "B", "C", "D"].map((option, optIndex) => {
                                                                        const selectedAnswers = (questionsData.answer || "")
                                                                            .split(",")
                                                                            .map(a => a.trim());

                                                                        const isSingleAnswer = true;

                                                                        return (
                                                                            // <Col sm={3} key={optIndex}>
                                                                            //     <div className={`custom-control ${isSingleAnswer ? "custom-radio" : "custom-checkbox"} mb-1`}>
                                                                            //         <input
                                                                            //             type={isSingleAnswer ? "radio" : "checkbox"}
                                                                            //             id={`opt_${questionsData.id}_${optIndex}`}
                                                                            //             name={`answer_${questionsData.id}`}
                                                                            //             className="custom-control-input"
                                                                            //             checked={selectedAnswers.includes(option)}
                                                                            //             onChange={() =>
                                                                            //                 this.handleAnswerChange(questionsData.id, option)
                                                                            //             }
                                                                            //             style={{ cursor: "pointer" }}
                                                                            //         />

                                                                            //         <label
                                                                            //             className="custom-control-label"
                                                                            //             htmlFor={`opt_${questionsData.id}_${optIndex}`}
                                                                            //         >
                                                                            //             {option}
                                                                            //         </label>
                                                                            //     </div>
                                                                            // </Col>




                                                                            <Col sm={3} key={optIndex}>
                                                                                <div className="custom-control custom-radio mb-1">
                                                                                    <input
                                                                                        type="radio"
                                                                                        id={`opt_${questionsData.id}_${optIndex}`}   // ✅ FIXED
                                                                                        name={`answer_${questionsData.id}`}
                                                                                        className="custom-control-input"
                                                                                        checked={selectedAnswers.includes(option)}
                                                                                        onChange={() => this.handleAnswerChange(questionsData.id, option)}
                                                                                    />

                                                                                    <label
                                                                                        className="custom-control-label"
                                                                                        htmlFor={`opt_${questionsData.id}_${optIndex}`}  // must match exact id
                                                                                    >
                                                                                        {option}
                                                                                    </label>
                                                                                </div>
                                                                            </Col>

                                                                        );
                                                                    })}
                                                                </Row>
                                                            </Card>)
                                                        }
                                                        else {
                                                            return (
                                                                <Card as={Card.Body} className="bg-light my-2">
                                                                    <div
                                                                        className="p-2"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <span>{this.idFunction(index)}</span>
                                                                        {parse(questionsData.question)}
                                                                        {" QID- " + questionsData.id}
                                                                    </div>

                                                                    <hr className="my-3" />
                                                                    <Row>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>A.</span>
                                                                                <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>B.</span>
                                                                                <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>C.</span>
                                                                                <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <span>D.</span>
                                                                                <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        {["A", "B", "C", "D"].map((option, optIndex) => {
                                                                            const selectedAnswers = (questionsData.answer || "")
                                                                                .split(",")
                                                                                .map(a => a.trim());

                                                                            const isSingleAnswer = true;

                                                                            return (
                                                                                // <Col sm={3} key={optIndex}>
                                                                                //     <div className={`custom-control ${isSingleAnswer ? "custom-radio" : "custom-checkbox"} mb-1`}>
                                                                                //         <input
                                                                                //             type={isSingleAnswer ? "radio" : "checkbox"}
                                                                                //             id={`opt_${questionsData.id}_${optIndex}`}
                                                                                //             name={`answer_${questionsData.id}`}
                                                                                //             className="custom-control-input"
                                                                                //             checked={selectedAnswers.includes(option)}
                                                                                //             onChange={() =>
                                                                                //                 this.handleAnswerChange(questionsData.id, option)
                                                                                //             }
                                                                                //             style={{ cursor: "pointer" }}
                                                                                //         />

                                                                                //         <label
                                                                                //             className="custom-control-label"
                                                                                //             htmlFor={`opt_${questionsData.id}_${optIndex}`}
                                                                                //         >
                                                                                //             {option}
                                                                                //         </label>
                                                                                //     </div>
                                                                                // </Col>


                                                                                <Col sm={3} key={optIndex}>
                                                                                    <div className="custom-control custom-radio mb-1">
                                                                                        <input
                                                                                            type="radio"
                                                                                            id={`opt_${questionsData.id}_${optIndex}`}   // ✅ FIXED
                                                                                            name={`answer_${questionsData.id}`}
                                                                                            className="custom-control-input"
                                                                                            checked={selectedAnswers.includes(option)}
                                                                                            onChange={() => this.handleAnswerChange(questionsData.id, option)}
                                                                                        />

                                                                                        <label
                                                                                            className="custom-control-label"
                                                                                            htmlFor={`opt_${questionsData.id}_${optIndex}`}  // must match exact id
                                                                                        >
                                                                                            {option}
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>

                                                                            );
                                                                        })}
                                                                    </Row>
                                                                </Card>
                                                            )
                                                        }
                                                    })}
                                                </Scrollbars>
                                            </Card>
                                        </Form.Row>
                                    ) : (
                                        <Row>
                                            <Col sm={12} style={{ color: "green", textAlign: "center" }}>
                                                No Data Found
                                            </Col>
                                        </Row>
                                    )
                                }
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    {
                        this.state.examquestionsData.length > 0 && (
                            <div className="d-flex align-items-center justify-content-end">
                                <Row>
                                    <Col sm={12}>
                                        {this.state.currentStep == 5 ? (
                                            <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                                {this.state.succssError}
                                            </Form.Text>
                                        ) : (
                                            <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                                {this.state.submitError}
                                            </Form.Text>
                                        )}</Col>
                                </Row>
                                <Button style={{ background: "linear-gradient(90deg, #8b51fB 0%, #e614e1 100%)", border: "none" }} onClick={this.handleSubmit}>  {
                                    this.state.loadingSpinner == 1 ?
                                        (<div class="spinner-border text-light  loading-img-center"></div>)
                                        :
                                        ("")
                                }Submit</Button>
                            </div>
                        )
                    }
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(withApollo(compose(
    graphql(EDIT_QUESTION, {
        name: "editQuestions"
    })
)(EditAnswerModal)));